import React from 'react';
import PropTypes from 'prop-types';
import Badge from 'react-bootstrap/Badge';
import { cx } from '@emotion/css';
import { formatDate, dateOnlySlashesFormat } from 'App/services/DateService';

const sortByDate = (rowA, rowB, columnId) => {
    return new Date(rowA.values[columnId]) - new Date(rowB.values[columnId]);
};

const DateCell = ({ value }) => <span>{formatDate(value, dateOnlySlashesFormat)}</span>;

DateCell.propTypes = {
    value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]).isRequired,
};

const SourceCell = ({ value }) => (
    <Badge
        pill
        className={cx('shared-tag-styles', {
            'source-is-self-reported': value === 'Self reported',
            'source-is-doctor-tag': value !== 'Self reported',
        })}
    >
        {value}
    </Badge>
);

SourceCell.propTypes = {
    value: PropTypes.string.isRequired,
};

const medicationsColumns = [
    {
        Header: 'Date',
        accessor: 'date',
        sortType: sortByDate,
        disableFilters: true,
        Cell: DateCell,
    },
    {
        Header: 'Medication',
        accessor: 'medication',
        disableFilters: true,
    },
    {
        Header: 'Source',
        accessor: 'source',
        disableFilters: true,
        Cell: SourceCell,
    },
];

const patientRecordTabs = [
    {
        eventKey: 'medications',
        title: 'Medications',
        settingKey: 'patientChartMedications',
        columns: medicationsColumns,
        initialState: { sortBy: [{ id: 'date', desc: true }] },
    },
    {
        eventKey: 'notes',
        title: 'Notes',
        settingKey: 'patientChartNotes',
        columns: [],
        initialState: {},
    },
    {
        eventKey: 'labs',
        title: 'Labs & Tests',
        settingKey: 'patientChartLabs',
        columns: [],
        initialState: {},
    },
    {
        eventKey: 'immunizations',
        title: 'Immunizations',
        settingKey: 'patientChartImmunizations',
        columns: [],
        initialState: {},
    },
    {
        eventKey: 'appointments',
        title: 'Appointments',
        settingKey: 'patientChartAppointments',
        columns: [],
        initialState: {},
    },
];

export { patientRecordTabs };
